export const PageHero = ({ eyebrow, title, subtitle }) => {
  return (
    <section className="relative bg-[#F2F9F5] border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28">
        {eyebrow && (
          <p
            data-testid="page-hero-eyebrow"
            className="text-sm font-semibold uppercase tracking-[0.2em] text-[#0B4F37] mb-4"
          >
            {eyebrow}
          </p>
        )}
        <h1
          data-testid="page-hero-title"
          className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#042D1F]"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            data-testid="page-hero-subtitle"
            className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};
